import { useState } from 'react';
import { Outlet, useMatch, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS } from '../constants/searchParamNames';
import GlobalWrapper from './GlobalWrapper';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';
import MobileNavigation from './MobileNavigation';
import LoadUtilityClassesLast from './LoadUtilityClassesLast';
import Authorization from './Authorization';
import Modals from './Modals';
import { last } from 'lodash';
import { LOGIN_REDIRECT } from '../constants/config';
import AuthorizationNoConsent from './AuthorizationNoConsent';

interface Props {
  children?: React.ReactNode;
  quizMode?: boolean;
}

const Layout: React.FC<Props> = ({ children, quizMode }) => {
  const [isAuthorizing, setIsAuthorizing] = useState(true);

  const isRedirectPage = useMatch(last(LOGIN_REDIRECT.split('/')) as string);
  const isPrivacyPolicyPage = useMatch('/profil/privatnost');
  const [searchParams] = useSearchParams();
  const hideHeaderFooter = quizMode
    ? true
    : (searchParams.get(SEARCH_PARAMS.HIDE_HEADER_FOOTER) ?? undefined);

  return (
    <>
      {isAuthorizing && !quizMode && (
        <Authorization setIsAuthorizing={setIsAuthorizing} />
      )}
      {isAuthorizing && quizMode && (
        <AuthorizationNoConsent setIsAuthorizing={setIsAuthorizing} />
      )}

      {!isAuthorizing && (
        <>
          <GlobalWrapper>
            {!hideHeaderFooter && <Header />}
            <Content noPadding={quizMode}>
              {children ?? ''}
              <Outlet />
            </Content>

            {!hideHeaderFooter && <Footer />}

            {!isPrivacyPolicyPage && !hideHeaderFooter && <MobileNavigation />}
            <LoadUtilityClassesLast />
          </GlobalWrapper>

          {!quizMode && <Modals />}
        </>
      )}

      {isRedirectPage && <Outlet />}
    </>
  );
};

export default Layout;
